import { render, staticRenderFns } from "./registrations-filters-index.vue?vue&type=template&id=67b172d2&scoped=true"
import script from "./registrations-filters-index.vue?vue&type=script&lang=js"
export * from "./registrations-filters-index.vue?vue&type=script&lang=js"
import style0 from "./registrations-filters-index.vue?vue&type=style&index=0&id=67b172d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b172d2",
  null
  
)

export default component.exports